import { withOneLineEllipsis } from 'style-utils/overflow';
import { withTypeface, WithTypefaceProps } from 'style-utils/text';
import styled, { StyledProps } from 'styled-components';
import createExtractCssFromProps from '../style-utils/createExtractCssFromProps';

const mappedProperties = {
  display: 'display',
  textSize: 'font-size',
  textWeight: 'font-weight',
  textAlign: 'text-align',
  textTransform: 'text-transform',
  textDecoration: 'text-decoration',
  whiteSpace: 'white-space',
  width: 'width',
  height: 'height',
  lineHeight: 'line-height',
  maxWidth: 'max-width',
  textColor: 'color',
  backgroundtextColor: 'background-textColor',
  padding: 'padding',
  margin: 'margin',
  wordBreak: 'word-break',
  overflow: 'overflow',
  letterSpacing: 'letter-spacing',
  cursor: 'cursor',
};

const mappedPropertiesMixin = createExtractCssFromProps(mappedProperties);

export type CommonTextProps = Omit<
  StyledProps<
    Parameters<typeof mappedPropertiesMixin>['0'] & WithTypefaceProps
  >,
  'color'
>;

export const Text = styled.span<CommonTextProps>`
  ${mappedPropertiesMixin};
  ${withTypeface};
`;

export const TextWithOneLineEllpsis = styled.span<CommonTextProps>`
  ${mappedPropertiesMixin};
  ${withOneLineEllipsis};
  ${withTypeface};
`;
TextWithOneLineEllpsis.defaultProps = {
  display: 'inline-block',
};

export type TextWithLineClampProps = CommonTextProps & { lineClamp: number };

export const TextWithLineClamp = styled.span<TextWithLineClampProps>`
  ${mappedPropertiesMixin};
  ${withTypeface};
  /* https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp */
  -webkit-box-orient: vertical;

  ${({ lineClamp }: { lineClamp: number }): string => {
    return `
      -webkit-line-clamp: ${lineClamp};
    `;
  }}
`;
TextWithLineClamp.defaultProps = {
  display: '-webkit-box',
  overflow: 'hidden',
  wordBreak: 'break-word',
};
